module.exports = __webpack_public_path__ + "static/media/Dragon.f1737a99.png";